import React from 'react';
import { Modal, Descriptions } from 'antd';
import moment from 'moment';

const PopupModal = ({ open, hideModal, student }) => {
  return (
    <Modal
      title="Student Information"
      centered
      open={open}
      onOk={hideModal}
      onCancel={hideModal}
      footer={null} // Remove default footer buttons
      width={800}
      className="custom-modal"
    >
      {student ? (
        <Descriptions
          bordered
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }} // Adjust column layout based on screen size
          layout="horizontal" // Use vertical layout for better readability
        >
          <Descriptions.Item label="Roll Number">{student.Roll_Number}</Descriptions.Item>
          <Descriptions.Item label="Class">{student.Class}</Descriptions.Item>
          <Descriptions.Item label="Section">{student.Section}</Descriptions.Item>
          <Descriptions.Item label="Name">{student.Student_name}</Descriptions.Item>
          <Descriptions.Item label="DOB">{moment(student.Dob).format('YYYY-MM-DD')}</Descriptions.Item>
          <Descriptions.Item label="Phone Number">{student.Phone_no}</Descriptions.Item>
          <Descriptions.Item label="Guardian Name">{student.Guardian_name}</Descriptions.Item>
          <Descriptions.Item label="Student Address">{student.Student_address}</Descriptions.Item>
          <Descriptions.Item label="State">{student.State_name}</Descriptions.Item>
          <Descriptions.Item label="District">{student.District}</Descriptions.Item>
          <Descriptions.Item label="School">{student.School}</Descriptions.Item>
          <Descriptions.Item label="Job Role">{student.Job_role}</Descriptions.Item>
          <Descriptions.Item label="Created At">{moment(student.createdAt).format('YYYY-MM-DD')}</Descriptions.Item>
        </Descriptions>
      ) : (
        <p>No Student data available.</p>
      )}
    </Modal>
  );
};

export default PopupModal;
